import {
  Box,
  Button,
  Center,
  CircularProgress,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { FuncButton } from "../../customComponents/components/FuncButton";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { head } from "../helpers";
import {
  useVehicleMarkDelete,
  useVehicleMarkList,
  useVehicleMarkSet,
} from "../hooks";

export const ColorListScreen = () => {
  const [activeMarkId, setActiveMarkId] = useState(null);
  const toast = useToast();
  const labelRef = useRef<HTMLInputElement>();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { vehicleMarkListLoading, vehicleMarkList, getVehicleMarkList } =
    useVehicleMarkList();
  const { vehicleMarkSetLoading, getVehicleMarkSet } = useVehicleMarkSet();
  const { vehicleMarkDeleteReq, vehicleMarkDeleteLoading } =
    useVehicleMarkDelete();

  useEffect(() => {
    getVehicleMarkList();
  }, []);

  const loading =
    vehicleMarkListLoading || vehicleMarkSetLoading || vehicleMarkDeleteLoading;

  const onClose = () => setModalIsOpen(false);

  const onSubmit = async () => {
    const label = labelRef?.current?.value;
    if (label) {
      const res = await getVehicleMarkSet({ id: activeMarkId, label });
      if (res.data.success) {
        toast({
          title: "Марка создана ",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      }
      getVehicleMarkList();
      setModalIsOpen(false);
    }
  };

  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Цвета автомобилей</Heading>}
        onClick={() => {
          setActiveMarkId(null);
          setModalIsOpen(true);
        }}
        linkLabel="Добавить цвет"
      >
        {loading ? (
          <Container height="calc(100vh - 240px)">
            <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
          </Container>
        ) : (
          <TableHead column={head}>
            {vehicleMarkList.map(({ id, label }) => (
              <Tr key={id}>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {id}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {label}
                  </Text>
                </Td>
                <Td isNumeric>
                  <FuncButton
                    onClick={() => {
                      setActiveMarkId(id);
                      setModalIsOpen(true);
                      setTimeout(() => {
                        labelRef.current.value = label;
                      }, 500);
                    }}
                  >
                    РЕДАКТИРОВАТЬ
                  </FuncButton>
                </Td>
                <Td isNumeric>
                  <Button
                    marginLeft={"20px"}
                    colorScheme="red"
                    onClick={() => {
                      if (window.confirm("Пожалуйста, подтвердите удаление")) {
                        vehicleMarkDeleteReq({ id }).then(() => {
                          getVehicleMarkList();
                        });
                      }
                    }}
                  >
                    Удалить
                  </Button>
                </Td>
              </Tr>
            ))}
          </TableHead>
        )}
      </PageHead>
      <Modal isOpen={modalIsOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Добавить цвет</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : (
              <FormControl>
                <FormLabel>Наименование</FormLabel>
                <Input ref={labelRef} placeholder="Наименование" />
              </FormControl>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Отменить
            </Button>
            <Button
              disabled={loading}
              colorScheme="blue"
              mr={3}
              onClick={onSubmit}
              marginLeft="20px"
            >
              {activeMarkId ? "Редактировать" : "Создать"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
